import {
    LANG_CHANGE_SUCCESS,
    LANG_CHANGE_FAIL,
    SET_MESSAGE
} from './type'

import languagesService from "../services/languages.service";
import viewinstanceService from "../services/viewinstance.service";

export const languageChange = (groupguid, languageId) => (dispatch) => {
  
    return languagesService.setLanguage(languageId).then(
      (data) => {
        dispatch({
          type: LANG_CHANGE_SUCCESS
        })
        .then(() => {
            console.log(languageId)
            viewinstanceService.getLanding(groupguid, languageId)
        });
        
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: LANG_CHANGE_FAIL,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };